import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
// import { ForgetPasswordPage } from "../pages/auth/components/forget-password.page";
// import { LoginPage } from "../pages/auth/components/login.page";
// import LandingPage from "../pages/landing.page";
// import { NotFoundPage } from "../pages/not-found.page";
// import { RedirectPage } from "../pages/redirect";
// import WebformLeadsPage from "../pages/web-form-leads";
// import { RootState } from "../shared/constants";
// import {
//   ROUTE_FORGET_PASSWORD,
//   ROUTE_LANDING,
//   ROUTE_LOGIN,
//   ROUTE_PAGE_NOT_FOUND,
//   ROUTE_REDIRECT_URL,
//   ROUTE_WEBFORM_LEADS,
// } from "../shared/routes/route.constants";
import LoginPage from "../../pages/Login/login.page";
import { RootState } from "../../shared/constants";
import DesktopLayout from "../../shared/layouts/desktop.layout";
import { PERMITTED_ROUTES } from "./permitted.routes";
import { ROUTE_LOGIN_APP } from "./ui.routes";

function RouteGuard({ ws, app, ...rest }: any) {
  const { token, user } = useSelector((state: RootState) => state.auth);
  console.log("RG", token, user);
  return (
    <Route
      {...rest}
      render={
        (props) =>
          token && user ? (
            <DesktopLayout>
              {PERMITTED_ROUTES.map((route: any, index: number) => {
                return (
                  <Route
                    exact
                    path={route.route}
                    key={index}
                    component={route.component}
                  />
                );
              })}
            </DesktopLayout>
          ) : (
            <>
              {" "}
              {/* Logged Out */}
              {/* <Route
                path={ROUTE_PAGE_NOT_FOUND()}
                exact={true}
                component={NotFoundPage}
              />
              <Route
                path={ROUTE_LOGIN(":account", ":source")}
                exact={true}
                component={LoginPage}
              />
              <Route
                path={ROUTE_FORGET_PASSWORD(":account", ":source", ":number")}
                exact={true}
                component={ForgetPasswordPage}
              />
              <Route
                path={ROUTE_LANDING(":account")}
                exact={true}
                component={LandingPage}
              />
              <Route
                path={ROUTE_WEBFORM_LEADS(":account")}
                exact={true}
                component={WebformLeadsPage}
              />
              <Route
                path={ROUTE_REDIRECT_URL(":id")}
                exact={true}
                component={RedirectPage}
              /> */}
              {/* <Redirect
                to={ROUTE_LOGIN(ACCOUNT_PREFIX, "crm")} */}
              {/* <Redirect
                to={ROUTE_LANDING(":account")}
                // to={{
                //   // pathname: ROUTE_LOGIN(account?.slug, app),
                //   pathname: "/" + ACCOUNT_PREFIX,
                //   state: { from: rest.location },
                // }}
              /> */}
              <Route
                path={ROUTE_LOGIN_APP}
                exact={true}
                component={LoginPage}
              />
              <Redirect to={ROUTE_LOGIN_APP} />
            </>
          )
        // <App {...props} />
      }
    />
  );
}

export default RouteGuard;
